/** User-facing tab keys (URL ?tab=). */
export const NOTIFICATION_TAB_RECEIVED = 'received';
export const NOTIFICATION_TAB_OUTGOING = 'outgoing';

export const NOTIFICATION_TABS = [
  { key: NOTIFICATION_TAB_RECEIVED, label: 'Received' },
  { key: NOTIFICATION_TAB_OUTGOING, label: 'Outgoing' },
];

export const parseNotificationTab = (searchParams) => {
  const tab = searchParams.get('tab');
  if (tab === NOTIFICATION_TAB_OUTGOING) return NOTIFICATION_TAB_OUTGOING;
  return NOTIFICATION_TAB_RECEIVED;
};
